import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, MessageSquare, ChevronRight } from "lucide-react";

/**
 * CUST-EXP-001A · "What you need to do" card.
 *
 * Only genuine, data-supported customer actions are surfaced.
 * Currently the sole real signal is unread messages from the
 * installer/operations team. Everything else falls through to a
 * calm, honest "You're all caught up." state — never fabricated.
 */
export default function ActionsCard({ unreadMessages = 0 }) {
    const hasAction = unreadMessages > 0;

    if (!hasAction) {
        return (
            <div className="pe-card p-5 md:p-6" data-testid="actions-card-empty">
                <div className="flex items-start gap-3">
                    <span className="w-10 h-10 rounded-xl bg-[#E6F1DE] text-[#2E7E22] flex items-center justify-center shrink-0">
                        <CheckCircle2 size={18} strokeWidth={1.75} />
                    </span>
                    <div className="flex-1 min-w-0">
                        <div className="text-[11px] tracking-[0.14em] uppercase text-[#4B5565]">What you need to do</div>
                        <div className="mt-1 text-lg text-[#131B2F] font-medium" data-testid="actions-card-title">
                            You're all caught up.
                        </div>
                        <p className="mt-1 text-sm text-[#4B5565]">
                            Nothing needs your attention right now — we'll let you know here if anything changes.
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="pe-card p-5 md:p-6" data-testid="actions-card">
            <div className="flex items-start gap-3">
                <span className="w-10 h-10 rounded-xl bg-[#FEEDE5] text-[#B45309] flex items-center justify-center shrink-0">
                    <MessageSquare size={18} strokeWidth={1.75} />
                </span>
                <div className="flex-1 min-w-0">
                    <div className="text-[11px] tracking-[0.14em] uppercase text-[#4B5565]">What you need to do</div>
                    <div className="mt-1 text-lg text-[#131B2F] font-medium">
                        {unreadMessages === 1 ? "You have 1 new message" : `You have ${unreadMessages} new messages`}
                    </div>
                    <p className="mt-1 text-sm text-[#4B5565]">
                        Reply to your installer to keep your installation on track.
                    </p>
                    <Link
                        to="/messages"
                        data-testid="actions-card-open-messages"
                        className="mt-3 inline-flex items-center gap-1.5 pe-btn-outline text-sm h-9"
                    >
                        Open messages <ChevronRight size={14} />
                    </Link>
                </div>
            </div>
        </div>
    );
}
